<template>
	<div grey-back full-height>

		<v-toolbar dark flat fixed nopadding>
      		<v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      		<v-toolbar-title>{{ $t('settings.labelPrint.title') }}</v-toolbar-title>
    	</v-toolbar>

	    <div class="hasToolbar">
	    	
	    	<div class="switches" white-background>
                <!-- <v-list two-line nopadding>
                    <v-list-tile class="padding-right-8">

                        <v-list-tile-content>
                            <v-list-tile-title>{{ $t('settings.labelPrint.enableLabelPrint') }}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ $t('settings.labelPrint.enableLabelPrintDesc') }}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-switch style="padding: 0 !important;" @change="fn_toggleLabelPrint" v-model="LabelPrintSettings.enableLabelPrint" nomargin></v-switch>
                        </v-list-tile-action>

                    </v-list-tile>
                </v-list> -->

                <!-- <template v-if="LabelPrintSettings.enableLabelPrint"> -->
                    <v-list nopadding>
                        <v-subheader grey-back>{{ $t('settings.labelPrint.printerSettings') }}</v-subheader>

                        <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>{{ $t('settings.labelPrint.language') }}</v-list-tile-title>
                            </v-list-tile-content>

                            <v-menu style="border-radius: 5px;">
                                <v-list-tile-action slot="activator" style="min-width: auto;flex-direction:row;justify-content:end;">
                                    <v-chip class="pr-1" small>{{ LabelPrintSettings.printLanguage.toUpperCase() }} <v-icon class="font20">arrow_drop_down</v-icon></v-chip>
                                </v-list-tile-action>

                                <v-list nopadding>
                                    <template>
                                        <v-list-tile @click="fn_savePrintLanguage('tspl')">
                                            <v-list-tile-content>
                                                <v-list-tile-title>TSPL</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
										<v-list-tile @click="fn_savePrintLanguage('zpl')">
                                            <v-list-tile-content>
                                                <v-list-tile-title>ZPL</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <!-- <v-list-tile @click="fn_savePrintLanguage('epl')">
                                            <v-list-tile-content>
                                                <v-list-tile-title>EPL</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile @click="fn_savePrintLanguage('dpl')">
                                            <v-list-tile-content>
                                                <v-list-tile-title>DPL</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile> -->
										<v-list-tile @click="fn_savePrintLanguage('shreyans')">
                                            <v-list-tile-content>
                                                <v-list-tile-title>SHREYANS</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile @click="fn_savePrintLanguage('esc/pos')">
                                            <v-list-tile-content>
                                                <v-list-tile-title>ESC/POS</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-menu>

                        </v-list-tile>

                        <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>{{ $t('settings.labelPrint.connectionType') }}</v-list-tile-title>
                            </v-list-tile-content>

                            <v-menu style="border-radius: 5px;" data-no-translate>
                                <v-list-tile-action slot="activator" style="min-width: auto;flex -direction:row;justify-content:end;">
                                    <v-chip class="pr-1" small>{{ LabelPrintSettings.printerConnectionType ? LabelPrintSettings.printerConnectionType.toUpperCase() : '' }} <v-icon class="font20">arrow_drop_down</v-icon></v-chip>
                                </v-list-tile-action>

                                <v-list nopadding>
                                    <template>
                                        <v-list-tile @click="fn_savePrinterConnectionType('bluetooth')">
                                            <v-list-tile-content>
                                                <v-list-tile-title>{{ $t('settings.labelPrint.bluetooth') }}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
										<v-list-tile @click="fn_savePrinterConnectionType('usb')">
                                            <v-list-tile-content>
                                                <v-list-tile-title>{{ $t('settings.labelPrint.usb') }}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-menu>

                        </v-list-tile>

                    </v-list>

                <!-- </template> -->
	    	</div>

	    </div>


	</div>
</template>

<script>
// const dialogjs =  require('../../masters/forms/dialog').dialogjs;
// const accountGroupIds = require('../../../config.js').configs.accountGroupIds;
// import dialogConfirmation from '../../dialogs/dialog_confirmation'
// import dialogText from '../../dialogs/dialog_text'

	export default{
		data(){
			return{
				LabelPrintSettings:{
                    "enableLabelPrint":false, 
                    "printLanguage":'tspl',
                    "printerConnectionType":'bluetooth'
                },
				formId:null,
				askToQuit:false,
				textDialogType:null,
				textDialogTitle:null,
				dialogTextContent:null,
                defaultPrinter:null
			}
		},
		// components:{
		// 	'dialog-text':dialogText
		// },
		methods:{
			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_post: function(){
                let dataObj = {LocalKey:'LabelPrintSettings',LocalValue:JSON.stringify(this.LabelPrintSettings)}
				this.$root.fn_saveLocalItem(dataObj, ()=>{
                    this.$root.fn_getLocalItem('LabelPrintSettings', response=>{
						let data = JSON.parse(response);
						if(data && data.LocalValue){
							this.$root.LabelPrintSettings = JSON.parse(data.LocalValue);
								if(this.$root.LabelPrintSettings && this.$root.LabelPrintSettings.enableLabelPrint){
								this.$root.fn_openThermalView();
							}
						}
                    });
                    this.showToast(this.$t('settings.labelPrint.settingsUpdated'));
                });
			},

			fn_toggleLabelPrint: function(value){
				this.LabelPrintSettings.enableLabelPrint = value;
				this.fn_post();
			},

            fn_savePrintLanguage: function(value){
                this.LabelPrintSettings.printLanguage = value;
                this.fn_post();
            },

            fn_savePrinterConnectionType: function(value){
                this.LabelPrintSettings.printerConnectionType = value;
                this.fn_post();
            }

			

			// fn_toggleImagePrint: function(value){
			// 	this.LabelPrintSettings.imagePrint = value;
			// 	this.fn_post();
			// }
	  	},

	  	mounted: function(){
	  		this.formId = this.guidWeb();
			this.dialogStorageId = 'dialog_'+this.formId;
	  		window.js_globals.fn_onBackPress = this.fn_goBack;
           
            this.$root.fn_getLocalItem('LabelPrintSettings', response=>{
                let data = JSON.parse(response);
				if(data && data.LocalValue){
					this.LabelPrintSettings = JSON.parse(data.LocalValue);
                    !this.LabelPrintSettings.printLanguage ? this.LabelPrintSettings.printLanguage = 'tspl' : '';
                    !this.LabelPrintSettings.printerConnectionType ? this.LabelPrintSettings.printerConnectionType = 'bluetooth' : '';
				}
			});

            // this.fn_getDefaultPrinter();
	  	},
	  	// beforeRouteLeave (to, from, next) {
	    // 	var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
		// 	if(dialogData && dialogData.length){
		// 		dialogjs.fn_checkAndCloseOpenDialogs(this);
		// 		next(false);
		// 	}
		// 	else if(this.askToQuit){
		// 		this.fn_openDialogConfirmation();
		// 		next(false);
		// 	}
		// 	else{
		// 		next();
		// 	}
	    // }
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/print_settings/label_print.vue